/* NAO theme interactions — vanilla JS, respects prefers-reduced-motion */
(function () {
  "use strict";
  // Brand motion is intentional and kept on for everyone (owner request).
  var reduce = false;

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Clinical bars ---- */
  function initBars() {
    var groups = document.querySelectorAll("[data-bars]");
    if (!groups.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      document.querySelectorAll(".bar-fill").forEach(function (b) { b.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.querySelectorAll(".bar-fill").forEach(function (b, i) {
              b.style.transitionDelay = i * 140 + "ms";
              b.classList.add("is-visible");
            });
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---- Animated counters ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-count"));
    var decimals = parseInt(el.getAttribute("data-decimals") || "0", 10);
    var prefix = el.getAttribute("data-prefix") || "";
    var suffix = el.getAttribute("data-suffix") || "";
    if (reduce) { el.textContent = prefix + target.toFixed(decimals) + suffix; return; }
    var start = performance.now(), dur = 1200;
    function tick(now) {
      var t = Math.min((now - start) / dur, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function initCounters() {
    var els = document.querySelectorAll("[data-count]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { els.forEach(animateCount); return; }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animateCount(e.target); io.unobserve(e.target); }
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Parallax bands ---- */
  function initParallax() {
    if (reduce) return;
    var layers = document.querySelectorAll(".band-dark__layer");
    if (!layers.length) return;
    var raf = 0;
    function update() {
      raf = 0;
      layers.forEach(function (layer) {
        var sec = layer.closest(".band-dark");
        if (!sec) return;
        var rect = sec.getBoundingClientRect();
        var progress = rect.top + rect.height / 2 - window.innerHeight / 2;
        layer.style.transform = "translate3d(0," + progress * 0.2 + "px,0)";
      });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
  }

  /* ---- Header scroll state ---- */
  function initHeader() {
    var header = document.querySelector(".site-header");
    if (!header) return;
    function onScroll() { header.classList.toggle("is-scrolled", window.scrollY > 8); }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Mobile nav ---- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var menu = document.querySelector("[data-mobile-nav]");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      var open = menu.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- FAQ accordion ---- */
  function initFaq() {
    document.querySelectorAll("[data-faq] button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-faq-item]");
        var open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });
  }

  /* ---- Sticky buy bar + plan toggle ---- */
  function initSticky() {
    var bar = document.querySelector("[data-sticky-buy]");
    if (!bar) return;
    var priceEl = bar.querySelector("[data-sticky-price]");
    var compareEl = bar.querySelector("[data-sticky-compare]");
    bar.querySelectorAll(".plan-toggle button").forEach(function (b) {
      b.addEventListener("click", function () {
        bar.querySelectorAll(".plan-toggle button").forEach(function (x) {
          x.setAttribute("aria-checked", "false");
        });
        b.setAttribute("aria-checked", "true");
        if (priceEl) priceEl.textContent = b.getAttribute("data-price") || priceEl.textContent;
        if (compareEl) {
          var c = b.getAttribute("data-compare");
          compareEl.textContent = c || "";
          compareEl.style.display = c ? "" : "none";
        }
      });
    });
    function onScroll() {
      var y = window.scrollY;
      var nearBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 320;
      bar.classList.toggle("is-visible", y > 640 && !nearBottom);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
  }

  /* ---- Instagram embeds (if any blockquotes present) ---- */
  function initInstagram() {
    if (!document.querySelector(".instagram-media")) return;
    var s = document.createElement("script");
    s.async = true;
    s.src = "https://www.instagram.com/embed.js";
    document.body.appendChild(s);
  }

  /* ---- Interactive clinical chart (tabs + hover tooltips) ---- */
  function initClinicalCharts() {
    document.querySelectorAll("[data-ci]").forEach(function (root) {
      var data;
      try { data = JSON.parse(root.getAttribute("data-ci")); } catch (e) { return; }
      if (!data.metrics || !data.metrics.length) return;
      var svg = root.querySelector(".ci-svg");
      var tip = root.querySelector(".ci-tip");
      var valEl = root.querySelector(".ci-value");
      var noteEl = root.querySelector(".ci-note");
      var nameEl = root.querySelector(".ci-name");
      var tabs = [].slice.call(root.querySelectorAll(".ci-tab"));
      var W = 480, H = 300, padL = 50, padR = 24, padT = 30, padB = 42;
      var maxY = data.max || 20;
      var labels = data.labels || [];

      function draw(idx, animate) {
        var m = data.metrics[idx];
        var pts = m.points || [];
        var n = pts.length;
        if (n < 2) return;
        var xs = [], ys = [];
        for (var i = 0; i < n; i++) {
          xs.push(padL + (W - padL - padR) * (i / (n - 1)));
          ys.push(H - padB - (H - padT - padB) * (Math.min(pts[i], maxY) / maxY));
        }
        var d = "M" + xs[0] + "," + ys[0];
        for (var i = 1; i < n; i++) d += " L" + xs[i] + "," + ys[i];
        var area = d + " L" + xs[n - 1] + "," + (H - padB) + " L" + xs[0] + "," + (H - padB) + " Z";
        var grid = "";
        for (var g = 0; g <= 3; g++) {
          var gy = padT + (H - padT - padB) * (g / 3);
          grid += '<line x1="' + padL + '" x2="' + (W - padR) + '" y1="' + gy + '" y2="' + gy + '" stroke="#EFEAE1" stroke-width="1"/>';
        }
        grid += '<text x="' + (padL - 8) + '" y="' + (padT + 4) + '" text-anchor="end" font-size="10" fill="#A89F94">+' + maxY + '%</text>';
        grid += '<text x="' + (padL - 8) + '" y="' + (H - padB + 4) + '" text-anchor="end" font-size="10" fill="#A89F94">0</text>';
        var xl = "", dots = "";
        for (var i = 0; i < n; i++) {
          xl += '<text x="' + xs[i] + '" y="' + (H - padB + 22) + '" text-anchor="middle" font-size="10" fill="#6E6862">' + (labels[i] || "") + "</text>";
          dots += '<circle class="ci-pt" cx="' + xs[i] + '" cy="' + ys[i] + '" r="5" fill="#fff" stroke="#C8102E" stroke-width="2.5" data-v="' + pts[i] + '" data-l="' + (labels[i] || "") + '" style="cursor:pointer"/>';
        }
        svg.innerHTML =
          '<defs><linearGradient id="ciA" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="rgba(200,16,46,0.26)"/><stop offset="100%" stop-color="rgba(200,16,46,0)"/></linearGradient></defs>' +
          grid +
          '<path d="' + area + '" fill="url(#ciA)" class="ci-area"/>' +
          '<path d="' + d + '" fill="none" stroke="#C8102E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="ci-path"/>' +
          dots +
          '<circle class="ci-end" cx="' + xs[n - 1] + '" cy="' + ys[n - 1] + '" r="6" fill="#C8102E"/>' +
          xl;
        var path = svg.querySelector(".ci-path");
        if (animate && !reduce && path.getTotalLength) {
          var len = path.getTotalLength();
          path.style.strokeDasharray = len;
          path.style.strokeDashoffset = len;
          path.getBoundingClientRect();
          path.style.transition = "stroke-dashoffset 1.2s ease";
          path.style.strokeDashoffset = "0";
        }
        svg.querySelectorAll(".ci-pt").forEach(function (pt) {
          pt.addEventListener("mouseenter", function () {
            if (!tip) return;
            tip.textContent = pt.getAttribute("data-l") + " · +" + pt.getAttribute("data-v") + "%";
            tip.style.opacity = "1";
            var bb = pt.getBoundingClientRect(), rb = root.getBoundingClientRect();
            tip.style.left = (bb.left - rb.left + bb.width / 2) + "px";
            tip.style.top = (bb.top - rb.top - 34) + "px";
          });
          pt.addEventListener("mouseleave", function () { if (tip) tip.style.opacity = "0"; });
        });
        if (valEl) valEl.textContent = m.value || "";
        if (noteEl) noteEl.textContent = m.note || "";
        if (nameEl) nameEl.textContent = m.name || "";
      }

      var cur = 0;
      function activate(i, animate) {
        cur = i;
        tabs.forEach(function (x) { x.classList.remove("is-active"); x.setAttribute("aria-selected", "false"); });
        if (tabs[i]) { tabs[i].classList.add("is-active"); tabs[i].setAttribute("aria-selected", "true"); }
        draw(i, animate);
      }
      var timer = null;
      function startAuto() {
        if (reduce || data.metrics.length < 2 || timer) return;
        timer = setInterval(function () {
          if (document.hidden) return;
          activate((cur + 1) % data.metrics.length, true);
        }, 3600);
      }
      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
      // Clicking still works and pauses the autoplay so the visitor can dwell.
      tabs.forEach(function (t, i) {
        t.addEventListener("click", function () { stopAuto(); activate(i, true); });
      });
      // Pause autoplay while hovering the chart.
      root.addEventListener("mouseenter", stopAuto);
      root.addEventListener("mouseleave", startAuto);
      activate(0, false);
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.isIntersecting) { activate(0, true); startAuto(); }
            else { stopAuto(); }
          });
        }, { threshold: 0.4 });
        io.observe(root);
      } else { startAuto(); }
    });
  }

  function init() {
    initReveal();
    initBars();
    initCounters();
    initParallax();
    initHeader();
    initMobileNav();
    initFaq();
    initSticky();
    initInstagram();
    initClinicalCharts();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // Re-init on Shopify theme editor section load
  document.addEventListener("shopify:section:load", init);
})();
